import React from 'react'
import AddComment from './AddComment'
import { Comment } from '../../../models/blog'

interface Props {
  comments: Comment[]
  renderDate: () => void
  id: number
}

export default function index(props: Props) {
  const { comments, id } = props

  return (
    <>
      <div>
        {comments.length > 0 && (
          <>
            <div className="text-2xl font-bold mb-8">
              {comments.length} Comment{comments.length > 1 && 's'}
            </div>
            {comments
              .filter(cmt => cmt.comment_approved === '1')
              .map(comment => (
                <div key={comment.comment_content} className="mb-4">
                  <div
                    className="mb-2 font-semibold text-1xl"
                    dangerouslySetInnerHTML={{ __html: comment.comment_author }}
                  />
                  <div
                    className="mb-8 text-md"
                    dangerouslySetInnerHTML={{
                      __html: comment.comment_content
                    }}
                  />
                </div>
              ))}
          </>
        )}
      </div>
      <AddComment id={id} comment={comments[0]} />
    </>
  )
}
